import React, { useState, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useGlobal } from 'reactn';
import { useTranslation } from 'react-i18next';
import useOnclickOutside from "react-cool-onclickoutside";
import { useAuth } from 'stores/auth';
import { useApi } from 'stores/api';
import { SlideDown } from 'react-slidedown';

const ShoppingCart = () => {
  const api = useApi();
  let history = useHistory();
  const { t } = useTranslation(['siteheader']);
  const { pathname } = useLocation();
  const [modalProps, setModalProps] = useGlobal('modalProps');
  const [cartCount] = useGlobal('cartCount');

  const onClickCart = e => {
    e.preventDefault();
    if (!cartCount) {
      setModalProps({ ...modalProps, showModal: true, messages: [t("emptyCart")] });
    } else {
      console.log(pathname);
      if (pathname === '/wizard/overview') {
        console.log('do nothing');
        return;
      }
      else if (pathname.startsWith('/wizard/options')) {
        setModalProps({
          ...modalProps,
          showModal: true,
          showCancel: true,
          okLabel: t("okLabelObjectRelease"),
          cancelLabel: t("cancelLabelObjectRelease"),
          messages: [t("cancelQuestionObjectRelease")],
          onOk: onOkRelease
        });
      } else {
        history.push('/wizard/overview');
      }
    }
  }

  const onOkRelease = async () => {
    await api.cancelTemporaryBooking(true);
    history.push('/wizard/overview');
  }

  const EmptyCart = () => {
    const [openMenu, setOpenMenu] = useState(false);
    const handleBtnClick = () => setOpenMenu(!openMenu);
    const closeMenu = () => setOpenMenu(false);
    const emptyRef = useOnclickOutside(() => closeMenu());

    return (
      <>
        <div ref={emptyRef}>
          <a className="shoppingBasket-link" onClick={handleBtnClick}>
            <i className="fa fa-shopping-cart" aria-hidden="true"></i>
            <div className="shoppingBasket-counter">0</div>
          </a>
        </div>
        <SlideDown className={'wy-dropdown'}>
          {openMenu && <div className="shoppingBasket-empty ignore-onclickoutside">{t("emptyCart")}</div>}
        </SlideDown>
      </>
    )
  }

  const NonEmptyCart = () => <a className="shoppingBasket-link" onClick={onClickCart}>
    <i className="fa fa-shopping-cart" aria-hidden="true"></i>
    <div className="shoppingBasket-counter">{cartCount}</div>
  </a>

  return (
    <div className="shoppingBasket-container">
      {!cartCount ? <EmptyCart /> : <NonEmptyCart />}
    </div>
  );
}

const LoggedOutDropdown = () => {
  let history = useHistory();
  const [iFrameError, setIframeError] = useState(false);
  const { t } = useTranslation(['siteheader']);

  const [openMenu, setOpenMenu] = useState(false);
  const handleBtnClick = () => setOpenMenu(!openMenu);
  const closeMenu = () => setOpenMenu(false);
  const outRef = useOnclickOutside(() => closeMenu());

  const gotoRoute = (e, route) => {
    e.preventDefault();
    history.push(route);
    closeMenu();
  }

  const onLoadIframe = () => {
    var iFrame = document.getElementById("login-iframe");
    if (iFrame) {
      let hasError = iFrame.contentWindow.document.querySelector(".alert-danger") != null;
      setIframeError(hasError);
    }    
  }

  return (
    <div className="column-3 offset-6 login-container">
      <div ref={outRef}>
        <a className="login small" onClick={handleBtnClick}>
          {t("login")} <i className="fa fa-heart" aria-hidden="true"></i>
        </a>
      </div>
      <SlideDown className={'wy-dropdown'}>
        {openMenu && (
          <div className={"login-overlay-container ignore-onclickoutside"}>
            <div className={`row iframe-holder${iFrameError?' iframe-error':''}`}>
              <iframe src={'/auth'} width={'100%'} height={'100%'} frameBorder="0" scrolling="no"
                id="login-iframe" onLoad={onLoadIframe}></iframe>
            </div>
            <div className="row secondary small">
              <a onClick={(e) => gotoRoute(e, '/register')}>{t("newRegistration")}</a>
              <a onClick={(e) => gotoRoute(e, '/forgotpassword')}>{t("passwordRecovery")}</a>
            </div>
          </div>
        )}
      </SlideDown>
      <ShoppingCart />
    </div>
  );
};

const LoggedInDropdown = () => {
  let history = useHistory();
  const auth = useAuth();
  const { t } = useTranslation(['siteheader']);

  const [openMenu, setOpenMenu] = useState(false);
  const handleBtnClick = () => setOpenMenu(!openMenu);
  const closeMenu = () => setOpenMenu(false);
  const inRef = useOnclickOutside(() => closeMenu());

  const logout = async (e) => {
    e.preventDefault();
    let result = auth.logout();
    if (result) {
      history.push('/');
    }
    closeMenu();
  }

  const gotoRoute = (e, route) => {
    e.preventDefault();
    history.push(route);
    closeMenu();
  }

  return (
    <div className="column-6 offset-3 login-container">
      <div ref={inRef}>
        <a className="login small" onClick={handleBtnClick}>
          {auth.user.AccountUsername} <i className="fa fa-heart" aria-hidden="true"></i>
        </a>
      </div>
      <SlideDown className={'wy-dropdown'}>
        {openMenu && (
          <div className={"login-overlay-container ignore-onclickoutside"}>
            <div className="row profile-dropdown">
              <a className="profile-link" onClick={(e) => gotoRoute(e, '/user/profile')}>
                <div className="profile-icon">
                  <i className="fa fa-user-circle" aria-hidden="true"></i>
                </div>
                <div className="profile-infos">
                  <div className="profile-name">{auth.user.AccountUsername}</div>
                </div>
              </a>
            </div>
            <div className="row secondary loggedin small">
              <a onClick={(e) => gotoRoute(e, '/user/profile')}>{t("userProfile")}</a>
              <a onClick={(e) => gotoRoute(e, '/user/bookings')}>{t("userBookings")}</a>
              <a className="logout" onClick={logout}><i className="fa fa-arrow-circle-right" aria-hidden="true"></i> {t("performLogout")}</a>
            </div>
          </div>
        )}
      </SlideDown>
      <ShoppingCart />
    </div>
  )
}

const SiteHeader = () => {
  const auth = useAuth();
  const api = useApi();
  let history = useHistory();

  const [isAutoLoggedOut] = useGlobal('isAutoLoggedOut');
  const [orderId] = useGlobal('orderId');
  const [cartCount] = useGlobal('cartCount');
  const logoImgSrc = window.ict?.wyby?.orgLogo;

  useEffect(() => {
    const handleMessagePost = async (ev) => {
      if (ev.data && ev.data === 'SIGNED_IN') {
        console.log('login success');
        console.log(window.location.pathname);
        await auth.login();
      }
    }
    window.addEventListener("message", handleMessagePost);
    return () => window.removeEventListener("message", handleMessagePost);
  }, []);

  useEffect(() => {
    if (isAutoLoggedOut) {
      history.push('/');
      if (cartCount > 0) {
        console.log('logged out...cancelling order');
        api.cancelOrder(orderId);
      }
    }
  }, [isAutoLoggedOut])

  return (
    <header className="header-container">
      <div className="wrapper">
        <div className="row">
          <div className="column-3">
            <div className="logo-container">
              <Link to="/"><img src={logoImgSrc} /></Link>
            </div>
          </div>
          {auth.user ? <LoggedInDropdown /> : <LoggedOutDropdown />}
        </div>
      </div>
    </header>
  );
}


export default SiteHeader;